//
// Culture Image Slider
//
import Flickity from "./flickity-loader";

let cultureResizeAbort = null;

const destroyFlickity = (el) => {
  const instance = Flickity.data(el);
  if (instance) {
    instance.destroy();
  }
};

export const initCultureImageSlider = () => {
  if (cultureResizeAbort) {
    cultureResizeAbort.abort();
  }
  cultureResizeAbort = new AbortController();
  const { signal } = cultureResizeAbort;

  const instances = [];

  document.querySelectorAll(".culture-img-slider").forEach(($ele) => {
    const slides = $ele.querySelectorAll(".culture-img-slide");
    let flkty = null;

    destroyFlickity($ele);

    if (slides.length > 1) {
      flkty = new Flickity($ele, {
        prevNextButtons: true,
        imagesLoaded: true,
        cellSelector: ".culture-img-slide",
        cellAlign: "left",
        lazyLoad: true,
        pageDots: false,
        adaptiveHeight: true,
        resize: true,
        accessibility: false,
      });
      instances.push(flkty);
    }

    const cultureImageNavSlider = $ele
      .closest(".culture-img-slider-wrap")
      ?.querySelector(".culture-img-nav-slider");

    if (!cultureImageNavSlider) {
      return;
    }

    destroyFlickity(cultureImageNavSlider);
    const cultureNavSlide = cultureImageNavSlider.querySelectorAll(".culture-img-nav-slide");

    if (cultureNavSlide.length > 1) {
      const navFlkty = new Flickity(cultureImageNavSlider, {
        prevNextButtons: false,
        imagesLoaded: true,
        asNavFor: $ele,
        cellSelector: ".culture-img-nav-slide",
        cellAlign: "left",
        lazyLoad: 3,
        pageDots: false,
        adaptiveHeight: false,
        contain: true,
        resize: true,
        accessibility: false,
      });
      instances.push(navFlkty);
    }
  });

  if (instances.length) {
    window.addEventListener(
      "resize",
      () => {
        setTimeout(() => {
          instances.forEach((instance) => instance?.resize());
        }, 100);
      },
      { signal }
    );
  }
};

if (document.querySelectorAll(".culture-img-slide").length) {
  initCultureImageSlider();
}
